import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  referrerNameAlt: () => i18n.t(i18nKeys.dasherApplyPage__referrerNameAlt),
  faq1Title: () => i18n.t(i18nKeys.dasherApplyPage__faq1__title),
  faq1Description: () => i18n.t(i18nKeys.dasherApplyPage__faq1__description),
  faq2Title: () => i18n.t(i18nKeys.dasherApplyPage__faq2__title),
  faq2Description: () => i18n.t(i18nKeys.dasherApplyPage__faq2__description),
  faq3Title: () => i18n.t(i18nKeys.dasherApplyPage__faq3__title),
  faq3Description: () => i18n.t(i18nKeys.dasherApplyPage__faq3__description),
  faq4Title: () => i18n.t(i18nKeys.dasherApplyPage__faq4__title),
  faq4Description: () => i18n.t(i18nKeys.dasherApplyPage__faq4__description),
  faq5Title: () => i18n.t(i18nKeys.dasherApplyPage__faq5__title),
  faq5Description: () => i18n.t(i18nKeys.dasherApplyPage__faq5__description),
  faq6Title: () => i18n.t(i18nKeys.dasherApplyPage__faq6__title),
  faq6Description: () => i18n.t(i18nKeys.dasherApplyPage__faq6__description),
  faq7Title: () => i18n.t(i18nKeys.dasherApplyPage__faq7__title),
  faq7Description: () => i18n.t(i18nKeys.dasherApplyPage__faq7__description),
  faq8Title: () => i18n.t(i18nKeys.dasherApplyPage__faq8__title),
  faq8Description: () => i18n.t(i18nKeys.dasherApplyPage__faq8__description),
  faq9Title: () => i18n.t(i18nKeys.dasherApplyPage__faq9__title),
  faq9Description: () => i18n.t(i18nKeys.dasherApplyPage__faq9__description),
  faq10Title: () => i18n.t(i18nKeys.dasherApplyPage__faq10__title),
  faq10Description: () => i18n.t(i18nKeys.dasherApplyPage__faq10__description),
  whatIsDoorDashTitle: () => i18n.t(i18nKeys.dasherApplyPage__doordash__title),
  whatIsDoorDashLine1: () =>
    i18n.t(i18nKeys.dasherApplyPage__doordash__description_line1),
  whatIsDoorDashLine2: () =>
    i18n.t(i18nKeys.dasherApplyPage__doordash__description_line2),
  signUpDetailsTitle: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__title),
  signUpDetailsSubtitle1: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1),
  signUpDetailsSubtitle1Line1: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line1),
  signUpDetailsSubtitle1Line2: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line2),
  signUpDetailsSubtitle1Line3: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line3),
  signUpDetailsSubtitle1Line4: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line4),
  signUpDetailsSubtitle1Line4ForJp: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line4ForJp),
  signUpDetailsSubtitle1Line5: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle1__line5),
  signUpDetailsSubtitle2: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2),
  signUpDetailsSubtitle2Line1: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line1),
  signUpDetailsSubtitle2Line2: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line2),
  signUpDetailsSubtitle2Line3: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line3),
  signUpDetailsSubtitle2Line4: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line4),
  signUpDetailsSubtitle2Line5: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line5),
  signUpDetailsSubtitle2Line6: () =>
    i18n.t(i18nKeys.dasherApplyPage__signup__details__subtitle2__line6),
  howToDash: () => i18n.t(i18nKeys.dasherApplyPage__howToDash__title),
  faqTitle: () => i18n.t(i18nKeys.common__faq),
}
